import { Faq } from "./faq-model";

export class FaqCategory {
  public id: string;
  public faqCategoryID: number;
  public name: string;
  public description: string;
  public faqCategoryIcon: string;
  public sortOrder: number;
  public isActive: boolean;
  public faqs: Faq[];
}



// WEBPACK FOOTER //
// ./src/app/models/faq/faq-category-model.ts